"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var pagination_1 = require("./pagination");

var accountTypes_1 = require("./accountTypes");

var AccountDTO = function AccountDTO() {
  _classCallCheck(this, AccountDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], AccountDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsEmail(), __metadata("design:type", String)], AccountDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsEnum(accountTypes_1.AccountTypes), __metadata("design:type", String)], AccountDTO.prototype, "type", void 0);

exports.AccountDTO = AccountDTO;

var AccountCreationDTO = function AccountCreationDTO() {
  _classCallCheck(this, AccountCreationDTO);
};

__decorate([class_validator_1.IsEmail(), __metadata("design:type", String)], AccountCreationDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], AccountCreationDTO.prototype, "password", void 0);

__decorate([class_validator_1.IsEnum(accountTypes_1.AccountTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], AccountCreationDTO.prototype, "type", void 0);

exports.AccountCreationDTO = AccountCreationDTO;

var AccountAskReinitPwdDTO = function AccountAskReinitPwdDTO() {
  _classCallCheck(this, AccountAskReinitPwdDTO);
};

__decorate([class_validator_1.IsEmail(), __metadata("design:type", String)], AccountAskReinitPwdDTO.prototype, "email", void 0);

exports.AccountAskReinitPwdDTO = AccountAskReinitPwdDTO;

var AccountUpdateDTO = function AccountUpdateDTO() {
  _classCallCheck(this, AccountUpdateDTO);
};

__decorate([class_validator_1.IsEmail(), class_validator_1.IsOptional(), __metadata("design:type", String)], AccountUpdateDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], AccountUpdateDTO.prototype, "password", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], AccountUpdateDTO.prototype, "newPassword", void 0);

exports.AccountUpdateDTO = AccountUpdateDTO;
var AccountOrderEnum;

(function (AccountOrderEnum) {
  AccountOrderEnum["createDate"] = "createDate";
})(AccountOrderEnum = exports.AccountOrderEnum || (exports.AccountOrderEnum = {}));

var AccountPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(AccountPaginationResponse, _pagination_1$Paginat);

  function AccountPaginationResponse() {
    _classCallCheck(this, AccountPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(AccountPaginationResponse).apply(this, arguments));
  }

  return AccountPaginationResponse;
}(pagination_1.PaginationResponse);

exports.AccountPaginationResponse = AccountPaginationResponse;